import { MenuTvItem } from '.';

export const SIDEBAR_MENU_TV: MenuTvItem[] = [
  {
    name: 'profile',
    icon: 'SolidUser',
    label: 'Meu perfil',
    onKidsMode: true,
    link: '/tvSubMenuArea',
    submenu: [
      {
        name: 'my-profile',
        icon: 'FaceSmile',
        label: 'Minha Conta',
        link: '/perfil',
        menu: 'profile',
        owner: true,
      },
      {
        name: 'faq',
        icon: 'CircleQuestion',
        label: 'Ajuda',
        link: '/ajuda',
        menu: 'profile',
      },
      {
        name: 'privacy-policies',
        icon: 'Lock',
        label: 'Política de Privacidade',
        link: '/termos',
        menu: 'profile',
      },
      {
        name: 'contact',
        icon: 'Envelope',
        label: 'Fale conosco',
        link: '/contato',
        menu: 'profile',
      },
      // { name: 'device', icon: 'Tv', label: 'Sobre o dispositivo', menu: 'profile' },
      {
        name: 'easter-egg',
        icon: 'Ghost',
        label: 'Developer Menu',
        menu: 'profile',
        easterEgg: true,
        link: '/easter-egg',
      },
      { name: 'loggout', icon: 'CircleXmark', label: 'Sair da Conta', onKidsMode: true },
    ],
  },
  { name: 'search', icon: 'MagnifyinGlass', label: 'Buscar', link: '/buscar', onKidsMode: true },
  { name: 'home', icon: 'HouseWindow', label: 'Início', link: '/', onKidsMode: true },
  { name: 'live', icon: 'Streaming', label: 'Agora', link: '/band-ao-vivo' },
  { name: 'watch', icon: 'ClapperboardPlay', label: 'Catálogo', link: '/assista' },
  { name: 'listen', icon: 'Radio', label: 'Ouça', link: '/ouca' },
  {
    name: 'favorites',
    icon: 'AudioLibrary',
    label: 'Minha Lista',
    link: '/favoritos',
    onKidsMode: true,
  },
];
